import React from 'react';
import { Paper, Grid, Typography} from 'material-ui';
import {withStyles} from 'material-ui/styles';
import DetailColumn from '../../Reservation/DetailColumn';
import RoomDetail from '../../Reservation/RoomDetail';
import moment from 'moment';
import { translate } from 'react-i18next';
import currencyFormatter from 'currency-formatter';

const styles = theme => ({
    expandIcon: {
        color: theme.palette.primary.main
    },
    title: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem'
    },
    paperFrame: {
        margin: '40px 0px'
    }
});

class ReservationModifyDetailsRender extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let dateIn = '';
        let dateOut = '';
        let adults = 0;
        let kids = 0;
        let updatedPrice = 0;
        let diff = this.props.diff;

        const { reservation, classes, t } = this.props;
        if (this.props.reservation) {
            if (this.props.reservation.checkIn) {
                dateIn = this.props.reservation.checkIn;
            } else {
                dateIn = this.props.reservation.checkInDate;
            }
            //lunes, 4 de Junio de 2018
            let mmformat = t('DATE_FORMAT.LONG');
            dateOut = moment(dateIn, 'DD/MM/YYYY')
                .add(this.props.reservation.nights, 'days')
                .format(mmformat);
            dateIn = moment(dateIn, 'DD/MM/YYYY').format(mmformat);
            this.props.reservation.checkOutDate = dateOut;

            adults =
                reservation && reservation.rooms ? reservation.rooms.reduce((acc, r) => acc + Number(r.adults), 0) : 0;

            kids =
                reservation && reservation.rooms
                    ? reservation.rooms.reduce((acc, r) => acc + Number(r.kids.length), 0)
                    : 0;

            updatedPrice = reservation && reservation.rooms ? reservation.rooms[0].price : 0;                  
        }
        return (
            <Paper className={classes.paperFrame}>
                
                <Typography className={classes.title}>
                    {t('CONFIRM_MODIFY_BOOKING.MODIFICATIONS_REQUESTED')}
                </Typography>
                <Grid container spacing={40} xs={12} style={{ padding: 24 }}>
                    <DetailColumn
                        {...[t('COMMON.CHECK_IN'), dateIn]}
                        diff={diff.checkIn}
                    />
                    <DetailColumn {...[t('COMMON.CHECK_OUT'), dateOut]}
                        diff={diff.checkOut}
                    />
                    <DetailColumn
                        {...[t('COMMON.NIGHTS'), this.props.reservation ? this.props.reservation.nights : '']}
                        diff={diff.nights}
                    />
                    {
                        this.props.reservation && this.props.reservation.rooms.length > 0 ? (
                            kids > 0 ? (
                                <DetailColumn {...[t('BOOKING_DETAIL.OCCUPATION'), adults + ' ' + t('COMMON.ADULTS'), kids + ' ' + t('COMMON.CHILDREN')]} diff={diff.rooms}/>
                            ) : (
                                <DetailColumn {...[t('BOOKING_DETAIL.OCCUPATION'), adults + ' ' + t('COMMON.ADULTS')]} diff={diff.rooms}/>
                            )
                        ) : (
                            <DetailColumn {...[t('BOOKING_DETAIL.OCCUPATION'), t('BOOKING_DETAIL.OCCUPATION_DETAIL_NOT_AVAILABLE')]} />
                        )
                    }
                    <Grid item xs={this.props.displayprice === true ? 2: 4} direction={'column'}>
                        <Typography style={{ fontWeight: 700, fontSize: '16px' }}>{t('BOOKING_DETAIL.SELECTION')}</Typography>
                        {this.props.reservation
                            ? this.props.reservation.rooms.map((r, index) => <RoomDetail diff={diff.rooms} key={index} {...r} />)
                            : ''}
                    </Grid>
                    {this.props.displayprice === true ? (
                        <Grid item xs={2} alignItems="flex-start">
                            <Typography style={{ textAlign: 'right', fontWeight: 700, fontSize: '16px' }}>
                                {this.props.currentprincelabel ? t('BOOKING_DETAIL.ACTUAL_PRICE') : t('BOOKING_DETAIL.PRICE')}
                            </Typography>
                            <Typography className={classes.price}>
                                {this.props.reservation
                                    ? currencyFormatter.format(updatedPrice, { code: 'EUR' })
                                    : '0€'}
                            </Typography>
                        </Grid>
                    ) : (
                            ''
                        )}
                </Grid>
            </Paper>
        );
    }
}
export default translate('translations')(withStyles(styles)(ReservationModifyDetailsRender));



// WEBPACK FOOTER //
// ./src/components/Reservation/Modification/ReservationModifyDetailsRender.js